import { useEffect, useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { ApiFehler } from "../api/client";
import { Hinweis, Knopf } from "../komponenten/Basis";
import { useAuth } from "../kontext/AuthKontext";
import { laeuftAlsApp } from "../lib/appInstallation";

export function LoginSeite() {
  const { benutzer, anmelden } = useAuth();
  const ort = useLocation();
  const [email, setEmail] = useState("");
  const [passwort, setPasswort] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(false);
  // Als installierte App liegt das Handy beim Installateur selbst: dann gleich vorausgewählt.
  const [bleiben, setBleiben] = useState(laeuftAlsApp);
  const ziel = (ort.state as { von?: string } | null)?.von ?? "/";

  // Titel für Suchmaschinen und Browser-Tab (die Login-Seite ist auf portal. indexierbar).
  useEffect(() => {
    const vorher = document.title;
    document.title = "Login für Installateure – AnmeldeMeister";
    return () => {
      document.title = vorher;
    };
  }, []);

  if (benutzer) return <Navigate to={ziel} replace />;

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    if (!email.includes("@") || !passwort) {
      setFehler("Bitte E-Mail und Passwort eingeben.");
      return;
    }
    setLaedt(true);
    try {
      await anmelden(email.trim(), passwort, bleiben);
    } catch (err) {
      setFehler(err instanceof ApiFehler ? err.message : "Anmeldung fehlgeschlagen");
    } finally {
      setLaedt(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-100 px-4">
      <form onSubmit={absenden} className="w-full max-w-sm rounded-2xl border border-neutral-200 bg-white p-8 shadow-karte" noValidate>
        <img src="/logo.png" alt="AnmeldeMeister" className="h-6 w-auto" />
        <h1 className="mt-6 text-xl font-semibold">Anmelden</h1>
        <p className="mt-1 text-sm text-neutral-500">Netzanmeldung &amp; Marktstammdatenregister – für Installateure und das AnmeldeMeister-Team</p>
        <div className="mt-6 space-y-4">
          <div>
            <label htmlFor="email" className="mb-1 block text-xs font-semibold">E-Mail</label>
            <input id="email" type="email" autoComplete="username" className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </div>
          <div>
            <label htmlFor="passwort" className="mb-1 block text-xs font-semibold">Passwort</label>
            <input id="passwort" type="password" autoComplete="current-password" className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm" value={passwort} onChange={(e) => setPasswort(e.target.value)} />
          </div>
          <label className="flex items-start gap-3 text-sm">
            <input type="checkbox" className="mt-0.5 h-5 w-5 shrink-0 accent-neutral-900" checked={bleiben} onChange={(e) => setBleiben(e.target.checked)} />
            <span>
              <span className="font-semibold">Angemeldet bleiben</span>
              <span className="block text-xs text-neutral-500">30 Tage, nur für Installateure. Bitte nur auf dem eigenen Handy.</span>
            </span>
          </label>
          {fehler && <Hinweis art="fehler">{fehler}</Hinweis>}
          <Knopf variante="primaer" type="submit" className="w-full" laedt={laedt}>Anmelden</Knopf>
        </div>
      </form>
    </div>
  );
}

export function NichtGefundenSeite() {
  return (
    <div className="mx-auto max-w-md py-24 text-center">
      <p className="text-5xl font-semibold">404</p>
      <p className="mt-2 text-neutral-600">Diese Seite gibt es nicht.</p>
      <a href="/" className="mt-6 inline-block rounded-lg bg-marke px-4 py-2 text-sm font-semibold text-white">Zur Startseite</a>
    </div>
  );
}
